// extracted by mini-css-extract-plugin
export default {"wrapper":"FestivalManager_wrapper__tHv71","flex_h_center":"FestivalManager_flex_h_center__NpTox"};